// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Jz-z","tooltipWrapper":"Kz-z","icon":"Lz-z","tooltip":"Mz-z","content":"Nz-z"};